import { ChangeDetectionStrategy, Component, DestroyRef, HostListener, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter, switchMap, timer } from 'rxjs';

import { SVG } from '@core/consts/SVGs';
import { ToastService } from '@shared/services/toast.service';
import { TOASTS } from '@core/consts/toast';

import { ButtonComponent } from '../button/button.component';

export const TOAST_DURATION = 5 * 1000;

@Component({
  selector: 'mdcr-toast',
  imports: [ButtonComponent],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit {
  private readonly toastService = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly toastType = this.toastService.toastType;

  public readonly TOASTS = TOASTS;
  public readonly SVG = SVG;

  public ngOnInit(): void {
    this.startAutoCloseTimer();
  }

  public onCancel(): void {
    this.toastService.closeToast();
    this.toastService.cancel();
  }

  public onConfirm(): void {
    this.toastService.confirm();
  }

  @HostListener('document:keydown.escape')
  public onEscape(): void {
    this.onCancel();
  }

  private startAutoCloseTimer(): void {
    this.toastService
      .getState()
      .pipe(
        filter(Boolean),
        filter(() => this.shouldAutoClose()),
        switchMap(() => timer(TOAST_DURATION)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.onCancel());
  }

  private shouldAutoClose(): boolean {
    const toast = TOASTS[this.toastType()];
    return !toast.confirmText && !toast.cancelText;
  }
}
